export default "__VITE_ASSET__CO4_Wxdg__"